import api, { pageData } from "./client";

export const liquidacionesApi = {
  getAll: async (params = {}) => pageData((await api.get("/liquidaciones/", { params })).data),
  getById: async (id) => (await api.get(`/liquidaciones/${id}/`)).data,
  preview: async (params) => (await api.get("/liquidaciones/previsualizar/", { params })).data,
  create: async (data) => (await api.post("/liquidaciones/", data)).data,
  cancel: async (id) => (await api.patch(`/liquidaciones/${id}/anular/`)).data,
};
